import { render, staticRenderFns } from "./prescriptList.vue?vue&type=template&id=20fa0737&scoped=true"
import script from "./prescriptList.vue?vue&type=script&lang=js"
export * from "./prescriptList.vue?vue&type=script&lang=js"
import style0 from "./prescriptList.vue?vue&type=style&index=0&id=20fa0737&prod&scoped=true&lang=css"
import style1 from "./prescriptList.vue?vue&type=style&index=1&id=20fa0737&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fa0737",
  null
  
)

export default component.exports